import { Button as MuiButton, useTheme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import SortButton from './SortButton'

import { Loader } from 'packages/eid-ui'
import FiltersButton from './FiltersButton'

const styles = {
    small: {
        padding: '3.25px 20px',
        minHeight: '35px',
    },
    medium: {
        padding: '5.25px 15px',
        minHeight: '39px',
    },
    large: {
        padding: '9.25px 30px',
        minHeight: '47px',
    },
}

const useStyles = makeStyles(() => ({
    root: (props) => ({
        textTransform: 'capitalize',
        fontSize: '16px',
        border: '1px solid transparent',
        borderRadius: '5px',
        ...props.variantStyles,
        ...props.style,
    }),
    startIcon: (props) => ({
        marginRight: props.size === 'large' ? '14px' : '10px',
    }),

    disabled: (props) => ({
        ...props.disabledStyles,
    }),
}))

const MobileButtons = (props) => {
    const {
        size,
        children,
        style,
        disabledStyles,
        loading,
        loaderColor,
        startIcon,
        endIcon,
        onClick,
        ...rest
    } = props
    const variantStyles = styles[size]

    const classes = useStyles({ style, variantStyles, size, disabledStyles })
    const theme = useTheme()

    return (
        <MuiButton
            startIcon={!loading && startIcon}
            endIcon={!loading && endIcon}
            size={size}
            classes={classes}
            onClick={!loading ? onClick : undefined}
            {...rest}
        >
            {!loading ? (
                children
            ) : (
                <Loader
                    color={
                        loaderColor
                            ? loaderColor
                            : theme?.palette?.common?.white
                    }
                    size={0.6}
                />
            )}
        </MuiButton>
    )
}

MobileButtons.Sort = SortButton
MobileButtons.Filter = FiltersButton

export default MobileButtons
